export default class GoogleNativeAd {
  constructor(element) {
    this.element = element;

    // Listen to message from child window (iframe ad postMessage)
    window.addEventListener('message', (event) => {
      const key = event.message ? 'message' : 'data';
      const data = event[key];
      const instance = data.adUnit || false;
      const eventName = data.message || 'ignore';

      // We're only managing native ad message listeners coming in. So quit if it's not.
      if (!instance || instance !== this.adUnit) return;

      // Handle the visibility of our element based on whether or not
      // ad content is available.
      if (eventName === 'adContentAvailable') {
        // If ad content is available, display it within our element.
        this.element.innerHTML = data.content;
      } else {
        // If no content is available, hide our element.
        this.element.classList.add('empty');
        const loader = this.element.querySelector('.loader');
        if (loader) loader.parentNode.removeChild(loader);
      }
    }, false);
  }

  // Returns this particular instance's ad unit id to help manage all
  // message listeners captured.
  get adUnit() {
    return this.element.getAttribute('data-container-ad-unit-id');
  }
}
